import * as React from 'react';
import { get, noop } from 'lodash';
import { compose, withHandlers, withProps, defaultProps } from 'recompose';
import { formValueSelector, reduxForm } from 'redux-form';
import { Row, Col, Grid } from 'react-flexbox-grid';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import {
  AutoCompleteField,
  AutoComplete,
  DateField,
  Date,
  RemoteAutoCompleteField,
  RemoteAutoComplete
} from '@components/form';
import { paymentMethodEnum } from '@modules/delicts/_delictsEnums';
import { payBNZTicket } from '@modules/tickets/_ticketsActions';
import { getActualDate } from '@utils/utils';
import { withNotifications } from '@components/hoc/withNotifications';
import { required } from '@utils/validators';
import { connect } from 'react-redux';

const enhance = compose<any, any>(
  defaultProps({ reloadDelict: noop }),
  withNotifications({ payBNZTicket }),
  withHandlers({
    onSubmit: ({ reloadDelict, ticketId, closeItem, payBNZTicketNotify }) => async formData => {
      const body = {
        bnpId: ticketId,
        bnzId: formData.bnzId,
        paymentMethod: formData.method,
        paymentTime: `${formData.payDate}:00.000Z`
      };
      const result = await payBNZTicketNotify(body);
      if (result) {
        await reloadDelict();
        closeItem();
      }
    }
  }),
  withProps({ initialValues: { payDate: getActualDate() } }),
  reduxForm({ form: 'module-events-delicts-bnz' }),
  connect(state => ({
    employeeId: formValueSelector('module-events-delicts-bnz')(state, 'employeeId')
  }))
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, employeeId }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>Platba přes BNZ</h4>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  name={'employeeId'}
                  label="Zaměstnanec *"
                  url={`/metropolis/api/hr/employees`}
                  fullWidth={true}
                  labelFunction={o => get(o, 'fullName')}
                  valueFunction={o => get(o, 'id')}
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  name="bnzId"
                  label="Doklad *"
                  url={'/metropolis/api/ed/tickets'}
                  params={{
                    sort: 'intNumber',
                    order: 'ASC',
                    filter: [
                      {
                        field: 'employee.id',
                        operation: 'EQ',
                        value: employeeId
                      },
                      {
                        field: 'type.id',
                        operation: 'EQ',
                        value: 'BNZ'
                      },
                      {
                        field: 'state.id',
                        operation: 'EQ',
                        value: 'ISSUED'
                      }
                    ]
                  }}
                  fullWidth={true}
                  labelFunction={o => get(o, 'fullNumber')}
                  valueFunction={o => get(o, 'id')}
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <AutoCompleteField
                  component={AutoComplete}
                  name={'method'}
                  label={'Způsob platby *'}
                  items={paymentMethodEnum}
                  labelFunction={o => get(o, 'label')}
                  valueFunction={o => get(o, 'id')}
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <DateField component={Date} name={'payDate'} label={'Datum zaplacení'} dateOnly={false} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Button label="Uložit a zavřít" primary={true} type={'submit'} style={{ margin: '8px' }} />
        <Button label="Zrušit" style={{ margin: '8px' }} onClick={closeItem} />
      </Grid>
    </form>
  </div>
);

export const EventsFormDelictsBNZPaymentForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDelictsBNZPaymentForm.tsx